export default __webpack_public_path__ + "static/5_29-86cf300fa14ecca87de28b528afa52f5.png";